// react
import { useContext, useEffect } from 'react';

// router
import { useLocation, useNavigate } from 'react-router-dom';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextBackStack } from '../../../App.context';

// mui
import { Button } from '@mui/material';

// icons
import { ChevronLeftOutlined as IconChevronLeft } from '@mui/icons-material';

// props
export interface BtnBackProps {
	pathsExcluded?: string[];
	sx?: object;
}

export const BtnBack = ({ pathsExcluded = [], sx }: BtnBackProps) => {
	// hooks
	const location = useLocation();
	const navigate = useNavigate();
	const { t } = useTranslation();

	// derived
	const { pathname } = location;

	// context
	const { pathnames, setPathnames } = useContext(ContextBackStack);

	const handleClickBack = () => {
		const pathnamesNew = [...pathnames];

		// default to dashboard if there is no previous pathname
		if (pathnamesNew.length <= 1) {
			navigate('/dashboard');
		}

		pathnamesNew.pop();

		const pathnamePrev = pathnamesNew[pathnamesNew.length - 1];

		if (pathnamePrev) {
			setPathnames(pathnamesNew);
			navigate(pathnamePrev);
		}
	};

	// set pathnames in context on location change
	useEffect(() => {
		setPathnames((pathnamesCurr) => {
			const pathnameLatest = pathnamesCurr[pathnamesCurr.length - 1];

			// return current pathnames if the current is same as latest
			if (pathname === pathnameLatest) {
				return pathnamesCurr;
			}
			// otherwise add pathname
			return [...pathnamesCurr, pathname];
		});
	}, [pathname, pathsExcluded, setPathnames]);

	if (pathsExcluded.includes(pathname)) {
		return null;
	}

	return (
		<Button color="inherit" startIcon={<IconChevronLeft />} sx={sx} onClick={handleClickBack}>
			{t('back')}
		</Button>
	);
};
